 
(function () {
  'use strict';

  var LIST = '[data-localization-search-list]';
  var INPUT = '[data-localization-search-input]';
  var ITEM = '.header-localization__item';
  var EMPTY = '[data-localization-search-empty]';

  function normalize(value) {
    return (value || '').trim().toLowerCase();
  }

  function filterList(list) {
    var input = list.querySelector(INPUT);
    if (!input) return;

    var query = normalize(input.value);
    var items = list.querySelectorAll(ITEM);
    var visible = 0;

    items.forEach(function (item) {
      var term = item.getAttribute('data-search-term') || '';
      var match = query === '' || term.indexOf(query) !== -1;
      item.hidden = !match;
      if (match) visible += 1;
    });

    var empty = list.querySelector(EMPTY);
    if (empty) empty.hidden = visible !== 0;
  }

  function resetList(list) {
    var input = list.querySelector(INPUT);
    if (input) input.value = '';
    list.querySelectorAll(ITEM).forEach(function (item) {
      item.hidden = false;
    });
    var empty = list.querySelector(EMPTY);
    if (empty) empty.hidden = true;
  }

 
  document.addEventListener('input', function (event) {
    var input = event.target.closest ? event.target.closest(INPUT) : null;
    if (!input) return;
    var list = input.closest(LIST);
    if (list) filterList(list);
  });

  
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target.closest ? event.target.closest(INPUT) : null;
    if (!input) return;
    event.preventDefault();
  });
 
  document.addEventListener('shown.bs.dropdown', function (event) {
    var disclosure = event.target.closest('.header-localization__disclosure');
    if (!disclosure) return;
    var list = disclosure.querySelector(LIST);
    if (!list) return; 
    resetList(list);
    var input = list.querySelector(INPUT);
    if (input) input.focus();
  });

  document.addEventListener('hidden.bs.dropdown', function (event) {
    var disclosure = event.target.closest('.header-localization__disclosure');
    if (!disclosure) return;
    var list = disclosure.querySelector(LIST);
    if (list) resetList(list);
  });
})();
